import { FC } from "react";
import { clipAmountString } from "../../helpers";
import { IconDenom } from "../icons/IconDenom";
import { Decimal } from "../numbers/Decimal";
import { Fiat } from "../numbers/Fiat";

export interface TransactionFeeItem {
  key: string;
  label: string;
  symbol: string;
  amount: bigint;
  decimals: number;
  valueUsd?: bigint;
}

export const TransactionFeeSummary: FC<{
  fees: TransactionFeeItem[];
  totalValueUsd: bigint;
}> = ({ fees, totalValueUsd }) => {
  const visibleFees = fees.filter((fee) => fee.amount > 0n);
  const hasPricedFees = visibleFees.some((fee) => fee.valueUsd !== undefined);

  return (
    <div className="flex ai-c jc-e wrap">
      {visibleFees.map((fee, index) => (
        <div
          key={fee.key}
          data-tooltip-id="global-tip"
          data-tooltip-content={`${fee.label}: ${clipAmountString(fee.amount, fee.decimals)} ${fee.symbol}${fee.valueUsd === undefined ? "" : ` ($${clipAmountString(fee.valueUsd, 8)})`}`}
          className="iflex ai-c color-grey">
          {index > 0 && <span className="mx-0.5">+</span>}
          <IconDenom denom={fee.symbol} className="w-2 h-2 block mr-0.5" />
          <Decimal
            amount={fee.amount}
            decimals={fee.decimals}
            symbol={fee.symbol}
            clip
            className="color-grey"
            symbolClassName="color-grey fs-14 condensed fw-500"
          />
        </div>
      ))}
      {hasPricedFees && (
        <span className="iflex ai-c color-grey ml-0.5">
          (
          <Fiat
            amount={totalValueUsd}
            symbol="$"
            decimals={8}
            clip
            className="color-grey"
            as="span"
          />
          )
        </span>
      )}
    </div>
  );
};
